// extracted by mini-css-extract-plugin
module.exports = {"laptopBreak":"mobile-break_laptopBreak__l_aMV","tabletBreak":"mobile-break_tabletBreak__MAl9x","mobileBreak":"mobile-break_mobileBreak__Yd4ES"};